import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router';

import { RouteError } from '@/components/RouteError';

export const Route = createRootRouteWithContext()({
  component: () => (
    <>
      <HeadContent />
      <Outlet />
    </>
  ),
  errorComponent: ({ error, reset }) => <RouteError error={error} reset={reset} />,
});
